module.exports = __webpack_public_path__ + "images/frontpage_autoplay@1x.png?e09fcdcf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontpage_autoplay@1x.png
// module id = 627
// module chunks = 7